import React from 'react'
import PropTypes from 'prop-types'
import { List, Map } from 'immutable'
import {
  TYPE_CONTENT_SERIES,
  TYPE_CONTENT_VIDEO,
  TYPE_CONTENT_COURSE,
} from '../../services/content-type/index'
import Link from '../Link/index'
import Dot from '../Icon/icons/Dot/index'
import { getContentTags } from '../../services/content/index'
import {
  TILE_V2_TAGS_SIZE_DEFAULT,
} from './constants'
import {
  getTileV2TagsClass,
  onClickTileTag,
} from './utils'

/**
 * List of tags for tiles and tile hover
 * @param {Object} props - The props
 * @param {String} props.contentType - The type of content
 * @param {String} props.size - The size of the tags, (default, small, etc)
 * @param {Map} props.data - The content data
 * @returns {JSX.Element} Tile tags component
 */
function TileV2Tags (props) {
  const {
    contentType,
    staticText,
    userLanguage,
    data,
  } = props
  const id = data.get('id')
  const url = data.get('url', '') || data.get('path', '')
  const references = List.isList(data.get('references')) ? data.get('references', List()) : List()
  const contentSubtype = data.get('contentSubtype')
  const displayType = data.get('displayType')
  const isNew = data.get('isNew', null)
  const hasNewEpisodes = data.get('hasNewEpisodes', false)
  const tags = getContentTags({
    tags: references,
    url,
    contentSubtype,
    isNew,
    hasNewEpisodes,
    contentType,
    staticText,
    userLanguage,
    displayType,
  }) || List()

  if (tags.size <= 0) {
    return null
  }

  if ((
    contentType !== TYPE_CONTENT_SERIES
    && contentType !== TYPE_CONTENT_VIDEO
    && contentType !== TYPE_CONTENT_COURSE
  )) {
    return null
  }

  return (
    <div className="tile-v2__tags">
      {
        tags.map((t, index) => {
          if (!Map.isMap(t)) {
            return null
          }

          const isLast = index === tags.size - 1

          return (
            <React.Fragment key={`${t}-${id}`}>
              {
                t.get('path')
                  ? <Link
                      to={t.get('path')}
                      className={getTileV2TagsClass({
                        baseClassName: 'tile-v2__tag',
                        linked: true,
                        type: t.get('type') || t.get('reference_type'),
                      })}
                      onClick={() => onClickTileTag({ ...props, tagId: t.get('content_id') || t.get('contentId'), tagName: t.get('name') || t.get('title') })}
                    >
                      {t.get('name') || t.get('title')}
                      {!isLast && (
                        <Dot size={14} color="#DADFE5" className="tile-v2__tag-separator" />
                      )}
                    </Link>
                  : <span className={getTileV2TagsClass({ baseClassName: 'tile-v2__tag', type: t.get('type') || t.get('reference_type') })}>
                      {t.get('name') || t.get('title')}
                      {!isLast && (
                        <Dot size={14} color="#DADFE5" className="tile-v2__tag-separator" />
                      )}
                    </span>
              }
            </React.Fragment>
          )
        })
      }
    </div>
  )
}

TileV2Tags.propTypes = {
  size: PropTypes.string,
}

TileV2Tags.defaultProps = {
  size: TILE_V2_TAGS_SIZE_DEFAULT,
}

export default TileV2Tags
